import { GET_CLIENTS_CREATE_FAILURE, GET_CLIENTS_CREATE_REQUEST, GET_CLIENTS_CREATE_SUCCESS, GET_CLIENTS_DROPDOWN_FAILURE, GET_CLIENTS_DROPDOWN_REQUEST, GET_CLIENTS_DROPDOWN_SUCCESS, GET_CLIENTS_FAILURE, GET_CLIENTS_REQUEST, GET_CLIENTS_SUCCESS, GET_ORG_FAILURE, GET_ORG_REQUEST, GET_ORG_SUCCESS } from "./clientsTypes";

const initialStateForClients = {
    loading: false,
    clients: [],
    error: "",
  };
  
  const getClientsReducer = (state = initialStateForClients, action) => {
    switch (action.type) {
      case GET_CLIENTS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_CLIENTS_SUCCESS:
        return {
          loading: false,
          clients: action.payload,
          error: "",
        };
      case GET_CLIENTS_FAILURE:
        return {
          loading: false,
          clients: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };

const initialStateForClientsSW = {
    loading: false,
    clients: [],
    error: "",
  };
  
  const getClientsForDropdownReducer = (state = initialStateForClientsSW, action) => {
    switch (action.type) {
      case GET_CLIENTS_DROPDOWN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_CLIENTS_DROPDOWN_SUCCESS:
        return {
          loading: false,
          clients: action.payload,
          error: "",
        };
      case GET_CLIENTS_DROPDOWN_FAILURE:
        return {
          loading: false,
          clients: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };

  const initialStated = {
  loading: false,
  documentType: [],
  error: "",
};

const getOrgReducer = (state = initialStated, action) => {
  switch (action.type) {
    case GET_ORG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ORG_SUCCESS:
      return {
        loading: false,
        documentType: action.payload,
        error: "",
      };
    case GET_ORG_FAILURE:
      return {
        loading: false,
        documentType: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

  const initialStatedSDW = {
  loading: false,
  clientTickets: [],
  error: "",
};

const getClientTicketReducer = (state = initialStatedSDW, action) => {
  switch (action.type) {
    case GET_CLIENTS_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENTS_CREATE_SUCCESS:
      return {
        loading: false,
        clientTickets: action.payload,
        error: "",
      };
    case GET_CLIENTS_CREATE_FAILURE:
      return {
        loading: false,
        clientTickets: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};
  export {getClientsReducer,getOrgReducer,getClientsForDropdownReducer,getClientTicketReducer}